// extracted by mini-css-extract-plugin
export default {"chatbot-button":"ChatbotButton_chatbot-button__99v9Q"};